import getErrorMessage from './getErrorMessage';

const handleRequestError = (error, reject) => {
    const code = error?.errors ? error.errors[0]?.code : null;
    const message = getErrorMessage(code);
    return reject(message);
};

export default handleRequestError;